import { useNavigate } from 'react-router-dom';
import Layout from '../../../components/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/Card';
import { Button } from '../../../components/ui/Button';
import { calculatorTools } from './calculatorTools';

const CALCULATOR_ROUTES = {
  'cable-limiting-temperature': '/tenant/tools/calculators/cable-limiting-temperature',
  'max-zs-values': '/tenant/tools/calculators/max-zs-values',
  'cable-size': '/tenant/tools/calculators/cable-size',
  'kva-calc': '/tenant/tools/calculators/kva-calc',
  'ohms-law': '/tenant/tools/calculators/ohms-law',
  'pfc-calc': '/tenant/tools/calculators/pfc-calc',
  'rfc-line-cpc-ratio': '/tenant/tools/calculators/rfc-line-cpc-ratio',
  'rfc-r1-r2-converter': '/tenant/tools/calculators/rfc-r1-r2-converter',
  'voltage-drop-ac': '/tenant/tools/calculators/voltage-drop-ac',
  'voltage-drop-dc': '/tenant/tools/calculators/voltage-drop-dc',
  'watt-amps-volts': '/tenant/tools/calculators/watt-amps-volts',
};

export default function Calculators() {
  const navigate = useNavigate();

  const handleCalculatorClick = (calculatorId) => {
    const path = CALCULATOR_ROUTES[calculatorId];
    if (path) {
      navigate(path);
    }
  };

  return (
    <Layout>
      <div className="space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100">Calculators</h1>
            <p className="text-xs text-gray-600 dark:text-gray-400 mt-1">
              Electrical calculation tools for your business
            </p>
          </div>
        </div>

        {/* Calculator Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {calculatorTools.map((tool) => {
            const Icon = tool.icon;
            return (
              <Card
                key={tool.id}
                className="hover:shadow-lg transition-shadow cursor-pointer bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700"
                onClick={() => handleCalculatorClick(tool.id)}
              >
                <CardHeader className="p-4 pb-3">
                  <div className="flex items-center space-x-2.5">
                    <div className="p-1.5 bg-blue-100 dark:bg-blue-900/30 rounded-lg">
                      <Icon className="h-4 w-4 text-blue-600 dark:text-blue-400" />
                    </div>
                    <CardTitle className="text-xs text-gray-900 dark:text-gray-100 font-semibold">
                      {tool.title}
                    </CardTitle>
                  </div>
                </CardHeader>
                <CardContent className="p-4 pt-0">
                  <p className="text-xs text-gray-600 dark:text-gray-400 mb-3">
                    {tool.description}
                  </p>
                  <Button
                    variant="outline"
                    size="sm"
                    className="h-8 w-full text-xs"
                  >
                    Open Calculator
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </Layout>
  );
}
